import { useId } from "react";
import { useTranslation } from "react-i18next";
import "./PolicyCredentials.css";

export function policyTransportError(credentials, selectedKey, active = true) {
  const users = credentials.filter(c => c.username.trim());
  if (selectedKey !== null && selectedKey !== undefined) {
    if (typeof selectedKey !== "string" || users.filter(c => c.key.trim() === selectedKey).length !== 1) return "policyTransport.invalid";
  } else if (active && users.length > 1) return "policyTransport.required";
  return null;
}

export default function PolicyCredentials({ credentials, selectedKey, onChange, editing, active }) {
  const { t } = useTranslation("space");
  const id = useId();
  const users = credentials.filter(c => c.username.trim());
  const error = policyTransportError(credentials, selectedKey, active);
  const effectiveKey = selectedKey ?? (users.length === 1 ? users[0].key.trim() : null);
  const change = (index, field, value) => {
    const next = credentials.map((c, i) => i === index ? { ...c, [field]: value } : c);
    // Renaming the selected row preserves the user's explicit choice.
    const key = field === "key" && selectedKey != null && credentials[index].key.trim() === selectedKey
      ? value.trim() : selectedKey;
    onChange(next, key);
  };
  return <fieldset className="policy-credentials" aria-describedby={`${id}-hint`}>
    <legend>{t("policyTransport.title")}</legend>
    <p id={`${id}-hint`} className="iio-field-hint">{t("policyTransport.hint")}</p>
    {error && <p role="alert" className="policy-credentials-error">{t(error)}</p>}
    <p className="iio-field-hint">{t("policies.praefixInfo")}</p>
    {credentials.map((cred, index) => {
      const unique = users.filter(c => c.key.trim() === cred.key.trim()).length === 1;
      return <div key={index} className="policy-credential-row">
        <div className="policy-credential-fields">
          {["key", "username", "password"].map(field => <div className="iio-field" key={field}>
            <label className="iio-field-label" htmlFor={`${id}-${index}-${field}`}>
              {t(field === "key" ? "policies.praefixKey" : field === "username" ? "policies.username" : "policies.passwort")}
            </label>
            <input id={`${id}-${index}-${field}`} className="iio-input" type={field === "password" ? "password" : "text"}
              value={cred[field]} onChange={e => change(index, field, e.target.value)}
              placeholder={field === "key" ? "APP_" : field === "password" && editing ? t("verbindung.unveraendert") : undefined} />
          </div>)}
          <button type="button" className="iio-btn iio-btn--secondary" aria-label={t("policyTransport.remove", { username: cred.username || t("policies.username") })}
            onClick={() => onChange(credentials.filter((_, i) => i !== index), selectedKey === cred.key.trim() ? null : selectedKey)}>
            {t("policies.credEntfernen")}
          </button>
        </div>
        <label className="policy-transport-choice">
          <input type="radio" name={`${id}-transport`} value={cred.key.trim()}
            checked={!error && unique && !!cred.username.trim() && effectiveKey === cred.key.trim()}
            disabled={!cred.username.trim() || !unique} aria-describedby={`${id}-hint`}
            aria-label={t("policyTransport.select", { username: cred.username || t("policies.username") })}
            onChange={() => onChange(credentials, cred.key.trim())} />
          {t("policyTransport.primary")}
        </label>
      </div>;
    })}
    <button type="button" className="iio-btn iio-btn--secondary" onClick={() => onChange([...credentials, { key: "", username: "", password: "" }], selectedKey)}>
      {t("policies.credHinzufuegen")}
    </button>
  </fieldset>;
}
